import { FunctionComponent, ReactNode } from 'react';
import { Outlet } from 'react-router';
import VMA from '../../features/vma/VMA';

interface SubNavigationLayoutProps {
    subNavigation: ReactNode;
}

/**
 * Layout component that places sub-navigation outside the app__content div
 * This ensures sub-navigation has its own scroll area independent of the main content
 */
const SubNavigationLayout: FunctionComponent<SubNavigationLayoutProps> = ({ subNavigation }) => (
    <>
        {subNavigation}
        <div id='content' className='app__content'>
            <VMA />
            <Outlet />
        </div>
    </>
);

export default SubNavigationLayout;
